export default "__VITE_PUBLIC_ASSET__0ddaf913__"